import React from 'react'
import styled from 'styled-components'
import { BsCheckCircleFill, BsGearFill } from 'react-icons/bs'
import { AiOutlineShoppingCart } from 'react-icons/ai'

function PackageAddOnSelection(props) {
  let currencySymbol = props.currencySymbol ?? '$'
  const toggleAddOnStatus = (id) => {
    let temp = props.addOns.map((addon) => {
      if (addon.identifier === id) {
        addon.addedToOrder = !addon.addedToOrder
      }
      return addon
    })
    props.setAddOns(temp)
  }
  const toggleAndSyncAddOnStatus = (id) => {
    let temp = props.addOns.map((addon) => {
      if (addon.identifier === id) {
        props.toggleOnClick(id, { addedToOrder: !addon.addedToOrder })
        addon.addedToOrder = !addon.addedToOrder
      }
      return addon
    })
    props.setAddOns(temp)
  }
  return (
    <div>
      {props.addOns &&
        props.addOns.map((addon) => {
          return (
            <LineWrapper key={addon.identifier} style={{ fontSize: '14px' }}>
              {addon.addedToOrder ? (
                <CheckMarkIcon
                  onClick={() =>
                    props?.toggleOnClick && props?.settingsOnClick
                      ? toggleAndSyncAddOnStatus(addon.identifier)
                      : toggleAddOnStatus(addon.identifier)
                  }
                ></CheckMarkIcon>
              ) : (
                <AddToCart
                  onClick={() =>
                    props?.toggleOnClick && props?.settingsOnClick
                      ? toggleAndSyncAddOnStatus(addon.identifier)
                      : toggleAddOnStatus(addon.identifier)
                  }
                >
                  <CartIcon />
                  Add To Cart
                </AddToCart>
              )}
              {addon.name ? (
                <AddOnText>
                  {addon.name} - {currencySymbol}
                  {addon.price}
                </AddOnText>
              ) : (
                <AddOnText>
                  {addon.packageAddOnTemplate.name} - {currencySymbol}
                  {addon.packageAddOnTemplate.price}
                </AddOnText>
              )}
              {props.settingsOnClick && (
                <IconButtonWrapper
                  style={{ marginLeft: 'auto', marginRight: '6px' }}
                  onClick={() => props.settingsOnClick(addon.identifier)}
                >
                  <SettingsIcon></SettingsIcon>
                </IconButtonWrapper>
              )}
            </LineWrapper>
          )
        })}
    </div>
  )
}

export default PackageAddOnSelection

const CheckMarkIcon = styled(BsCheckCircleFill)`
  font-size: 20px;
  margin-right: 4px;
  color: var(--forward);
  cursor: pointer;
`

const SettingsIcon = styled(BsGearFill)`
  font-size: 20px;
  margin-right: 4px;
  color: #6f7378;
  :hover {
    opacity: 50%;
  }
`

const LineWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 4px 0;
  margin: 4px 0;
`
const AddOnText = styled.p``

const IconButtonWrapper = styled.div`
  display: flex;
`

const CartIcon = styled(AiOutlineShoppingCart)`
  font-size: 20px;
  margin: 0 10px 0 0;
  padding: 0;
`
const AddToCart = styled.div`
  border: 1px solid;
  padding: 3px 8px;
  border-radius: 30px;
  margin: 0 10px 0 0;
  display: flex;
  align-items: center;
  cursor: pointer;
`
